<template>
  <div class="login-panel full-bg">
    <el-form
      ref="form"
      :model="form"
      class="login-form d-flex flex-column justify-content-around"
    >
      <div
        style="
          color: #000;
          font-size: 2.4rem;
          line-height: 2.4rem;
          margin-bottom: 1rem;
        "
      >
        欢迎登录
      </div>
      <el-input
        class="login-form-item"
        placeholder="请输入用户名"
        v-model="form.UserName"
      >
        <template slot="prepend">用户名</template>
      </el-input>
      <el-input
        class="login-form-item"
        type="password"
        placeholder="请输入密码"
        v-model="form.PWD"
        :show-password="true"
      >
        <template slot="prepend">密码</template>
      </el-input>
      <el-form-item class="login-form-item">
        <el-col :span="18">
          <el-input v-model="form.VerifyCode" placeholder="请输入验证码">
            <img
              slot="suffix"
              ref="VerifyCode"
              style="width: 60px; height: 80%; margin-top: 10%"
              :src="`${loginVerifyCode}${form.sid}`"
            />
          </el-input>
        </el-col>
        <el-col :span="6" style="color: black; line-height: 20px">
          <div class="" style="font-size: 12px">看不清?</div>
          <a
            style="
              text-decoration: underline;
              color: lightblue;
              cursor: pointer;
            "
            @click="reloadVerifyCode"
            >换一张</a
          >
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          class="login-form-button login-form-item"
          v-on:click="submit"
          :loading="isLogining"
          >登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { loginVerifyCode } from '@/api/login/index';
import { convertDataToFormData, uuid } from '@/utils/utils';
import { _BASE_Configuration } from '@/const/values.js';
import md5 from 'crypto-js/md5';

export default {
  name: 'login-panel',
  data() {
    return {
      isLogining: false,
      loginVerifyCode,
      form: {
        UserName: '',
        PWD: '',
        VerifyCode: '',
        sid: uuid()
      },
      isShow: _BASE_Configuration
    };
  },
  created() {
    const that = this;
    document.onkeydown = function () {
      // 按下回车提交
      const key = window.event.keyCode;
      // 事件中keycode=13为回车事件
      if (key === 13) {
        that.loginSystem();
      }
    };
  },
  methods: {
    ...mapActions('systemManage', ['setSystemManageAction']),
    submit() {
      this.loginSystem();
    },
    reloadVerifyCode() {
      this.form.sid = uuid();
      this.$refs.VerifyCode.src = `${loginVerifyCode}${this.form.sid}`;
    },
    loginSystem() {
      if (!this.verifyLoginInput()) {
        return;
      }
      this.isLogining = true;
      const formData = convertDataToFormData(this.form);
      const md5Code = md5(this.form.PWD).toString();
      debugger
      formData.set('PWD', md5Code);
      this.$store
        .dispatch('user/login', formData)
        .then(() => {
          var type = this.$route.params.type;
          if (type == 2) {
            this.$router.push({
              name: 'equipment_details'
            });
          } else {
            // 更新树形图
            this.$store.dispatch('projects/projectList');
            this.setSystemManageAction({}).then((_) => {
              debugger
              if(this.isShow) {
                this.$router.push({
                  name: 'Home'
                });
              } else {
                window.location.href = '/Home/index';
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.reloadVerifyCode();
        })
        .then(() => {
          this.isLogining = false;
        });
    },
    verifyLoginInput() {
      if (!this.form.UserName) {
        this.$message({
          message: '请输入账号',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.PWD) {
        this.$message({
          message: '请输入密码',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.VerifyCode) {
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped lang="less">
/deep/.el-input-group__append,
/deep/.el-input-group__prepend {
  color: #666;
}

.login-form {
  border-radius: 8px;
  box-shadow: 0px 6px 12px 0px rgba(71, 70, 74, 0.71);
}

.input-container {
  display: -ms-flexbox;
  /* IE10 */
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

.container-border {
  border: solid 1px lightblue;
}

.icon {
  padding: 10px;
  background: white;
  color: black;
  min-width: 20px;
  text-align: center;
}

.input-field {
  width: 100%;
  padding: 10px;
  outline: none;
  border: none;
}

.input-field:focus {
  border: 2px solid dodgerblue;
}

/* Set a style for the submit button */
.login-form-button {
  background-color: dodgerblue;
  border: none;
  cursor: pointer;
  width: 100%;
  opacity: 0.9;
  height: 3rem;
  font-size: 1.5rem;
}

.btn:hover {
  opacity: 1;
}

.login-form {
  padding: 40px;
  background-color: white;
  height: calc(100% - 80px);
}

.input-border {
  border: solid 1px lightblue;
}

.verify-code-image {
  height: 38px;
  width: 100%;
  margin-left: 10px;
  border: solid 1px lightgray;
  border-radius: 4px;
}

.login-form-item {
  margin-top: 6px;
}

/deep/.login-form-item > .el-input-group__append,
/deep/.login-form-item > .el-input-group__prepend,
.login-form-item /deep/.el-input__inner {
  border: none;
  border-bottom: solid 2px #eaeaef;
  background-color: white;
  border-radius: 0;
  font-size: 1.4rem;
}
</style>